module.exports = __webpack_public_path__ + "public/img/19.7c30ef6d.png";